import {
    snakeCase,
    text,
    timestamp,
    varchar,
    boolean,
    numeric,
    integer,
    index,
} from 'drizzle-orm/pg-core'
import { id, timestamps } from '../utils/columns.helpers'
import { benefitsTable } from './benefits.table'

export const benefitSchedulesTable = snakeCase.table(
    'benefit_schedules',
    {
        id: id('bsch'),
        benefitId: text()
            .notNull()
            .references(() => benefitsTable.id, {
                onDelete: 'cascade',
                onUpdate: 'cascade',
            }),
        scheduleType: varchar({ length: 50 })
            .$type<'campaign' | 'blackout' | 'peak_season' | 'day_of_week'>()
            .notNull(),

        startDate: timestamp({ withTimezone: true }).notNull(),
        endDate: timestamp({ withTimezone: true }).notNull(),
        dayOfWeek: integer(), // 0 = Sunday, 1 = Monday ... 6 = Saturday

        // Action Modifiers
        isBlocked: boolean().default(false), // true if blackout / non-redeemable
        discountMultiplier: numeric({ precision: 4, scale: 2 }).default('1.00'), // e.g. 1.50x
        discountOverridePercent: numeric({ precision: 5, scale: 2 }), // Flat override e.g. 30%

        description: text(),
        ...timestamps,
    },
    (table) => [
        index('benefit_schedules_benefit_idx').on(table.benefitId),
        index('benefit_schedules_window_idx').on(
            table.benefitId,
            table.startDate,
            table.endDate,
        ),
    ],
)
